module.exports = __webpack_public_path__ + "media/packs/images/flags/ES-2e5ea1f37c20c8e4f24655b3708a8151.png";